import AuthorizeMobilePay from './AuthorizeMobilePay.vue'

export default {
    path: 'authorize',
    component: AuthorizeMobilePay
}